import { useContext, useState } from 'react';
import * as React from 'react';

import { TranscriptionService, type TranscriptionResponseDTO } from '@klangio/ai2notes-ts-client';
import type { WithUser } from '../../../context';
import { AppConstantsContext, withUserContext } from '../../../context';
import ExportTranscriptionContext from '../../../context/ExportTranscription/ExportTranscriptionContext';
import type { ExportType } from '../../../entities';
import { TrackingAction, TrackingCategory, trackingService } from '../../../services';
import LoginRequiredDialog from '../../organisms/Dialogs/LoginRequiredDialog';

import DropDownContent from './DropDownContent';
import DropdownButton from './DropdownButton';

export type DownloadMenuVariant = 'songbook' | 'sheet';

export interface SheetDownloadButtonProps extends WithUser {
  transcription: TranscriptionResponseDTO;
  hasTicketsForUse: boolean;
  onUnlockTranscriptionFinish: (jobId: string) => void;
  showPricingTable?: (open: boolean) => void;
}

const SheetDownloadButton: React.FC<SheetDownloadButtonProps> = ({
  transcription,
  showPricingTable,
  user,
  onUnlockTranscriptionFinish,
  hasTicketsForUse,
}) => {
  const { isMusehub, musehubPurchaseUrl } = useContext(AppConstantsContext);
  const [loginRequiredDialogOpen, setLoginRequiredDialogOpen] = useState(false);
  const { onDownload } = useContext(ExportTranscriptionContext);

  const setTrackingEvent = (
    exportType: ExportType,
    category: TrackingCategory,
    action: TrackingAction,
  ) => {
    const trackingValues = {
      export_type: exportType,
      ui_element: 'download',
      location: 'sheet',
      pricingModal: transcription.demo && !hasTicketsForUse,
    };
    trackingService.valueObjectEvent<{
      export_type: ExportType;
      location: DownloadMenuVariant;
      ui_element: string;
      pricingModal: boolean;
    }>(category, action, {
      ...trackingValues,
    });
    // console.log(action, { ...trackingValues });
  };

  const handleDownloadClick = (type: ExportType) => {
    setTrackingEvent(type, TrackingCategory.Transcription, TrackingAction.EXPORT_CLICK);
    if (!user && transcription.demo) {
      setLoginRequiredDialogOpen(true);
    } else {
      onDownload(transcription, type);
    }
  };
  const handleUnlockTranscription = (type: ExportType) => {
    setTrackingEvent(type, TrackingCategory.Buy, TrackingAction.BUY_UNLOCK);
    if (transcription.demo && !hasTicketsForUse) {
      if (isMusehub) {
        console.log('Open musehub link: ', musehubPurchaseUrl);
        window.open(musehubPurchaseUrl, '_blank');
      } else {
        showPricingTable(true);
      }
    } else {
      TranscriptionService.transcriptionUnlock(transcription.id).then((res) =>
        onUnlockTranscriptionFinish(res.jobId));
    }
  };
  return (
    <>
      {!user && transcription.demo && (
        <LoginRequiredDialog
          open={loginRequiredDialogOpen}
          onClose={() => setLoginRequiredDialogOpen(false)}
        />
      )}
      <DropdownButton variant="sheet">
        <DropDownContent
          transcription={transcription}
          handleUnlockTranscription={handleUnlockTranscription}
          handleDownloadClick={handleDownloadClick}
        />
      </DropdownButton>
    </>
  );
};

export default withUserContext(SheetDownloadButton);
